<template>
  <button @click="back()"><img src="@/assets/img/back-icon.svg" alt="preview" /></button>
</template>
<script>
export default {
  name: "inc_back",
  props: {},
  watch: {},
  mounted() {},
  methods: {
    back() {
      //   this.$router.go(-1);
      //   history.back();
      history.go(-1);
    },
  },
};
</script>
